import type { GetStaticProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { UploadPageLayout } from "components/modules/Layout/UploadPageLayout/UploadPageLayout";
import { EnlargerContent } from "components/modules/Content/EnlargerContent/EnlargerContent";
import { EnlargerTutorial } from "components/modules/Tutorial/EnlargerTutorial/EnlargerTutorial";
import Head from "next/head";
import { commonLanguageFiles } from "client/config";
import { LanguageProvider } from "client/contexts/LanguageProvider";
import { translateFunc } from "client/utils/translateFunc";
import { Translate } from "components/common/Translate/Translate";
import { Navbar } from "components/modules/Navigation/Navbar/Navbar";
import dynamic from "next/dynamic";

const EnlargeUploader = dynamic<{}>(() =>
    import("components/modules/Uploader/Enlarge/EnlargeUploader").then((mod) => mod.EnlargeUploader),
);

const Page = () => {
    const title = translateFunc("page-title");
    const description = translateFunc("meta-description");

    return (
        <>
            <Head>
                <title>{title}</title>
                <meta name="description" content={description} />
                <meta property="og:type" content="website" />
                <meta property="og:title" content={title} />
                <meta property="og:description" content={description} />
                <meta property="og:image" content="/social.png" />
                <meta property="twitter:card" content="summary" />
                <meta property="twitter:title" content={title} />
                <meta property="twitter:description" content={description} />
            </Head>
            <UploadPageLayout
                navbar={<Navbar url="/image-enlarger" />}
                title={<Translate keyName="title" />}
                subTitle={<Translate keyName="sub-title" />}
                uploader={<EnlargeUploader />}
                content={<EnlargerContent />}
                tutorial={<EnlargerTutorial />}
                pageUrl="/image-enlarger"
            />
        </>
    );
};
const files = ["enlarger-landing", "uploader", ...commonLanguageFiles];

const LanguageWrapper = () => {
    return (
        <LanguageProvider files={files}>
            <Page />
        </LanguageProvider>
    );
};

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
    props: {
        ...(await serverSideTranslations(locale ?? "", files)),
    },
});

export default LanguageWrapper;
